import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HomeServices from "../../Services/HomeServices";
import "./Pages.css";
import { useNavigate } from "react-router-dom";

const AddDocumentType = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const initValue = {
    document: "",
  };
  const [formValue, setFormValue] = useState(initValue);

  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formValue.document) return toast.error("Document should not be empty")
    
    try {
      const response = await HomeServices.addDocumentType(formValue)
      
      if (response.status) {
        console.log("EERE25",response);
        // formValue(initValue)
        toast.success(response.message)
        navigate("/document-type")
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }

  };

  return (
    <>

      <div className="d-flex justify-content-end mt-5">
        <div className="form-header">
          <section className="piechartsBox_area">
            {/* <BackPageBtn backLink="/" /> */}

            <form>

              <div>
                <h1 style={{ color: "#ff9c00" }}>Add Document Type</h1>
              </div>

              <div className="row mt-4">
                <div className="col">
                  <label htmlFor="formGroupExampleInput">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Document type"
                    name="document"
                    value={formValue?.document}
                    onChange={(e) => { setFormValue({ ...formValue, document: e.target.value }) }}
                  />
                </div>
              </div>

              {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}
              <div class="col-12 ">

                <button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                  style={{
                    background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                    color: "#fff",
                  }}
                >
                  Add
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>



    </>
  );
};

export default AddDocumentType;
